"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.bubbleUpHierarchyNodeUpdates = exports.collapseChildNodes = exports.HierarchyGraphReducer = exports.HierarchyNodeActionCreator = exports.HierarchyGraphActionTypes = void 0;
var axios_1 = __importDefault(require("axios"));
var Constants_1 = require("../Constants");
var HierarchyTypeUtil_1 = require("../HierarchyTypeUtil");
var HtmlUtil_1 = require("../util/HtmlUtil");
var HierarchyGraphActionTypes;
(function (HierarchyGraphActionTypes) {
    HierarchyGraphActionTypes["NODE_TOGGLE"] = "NODE_TOGGLE";
    HierarchyGraphActionTypes["NODES_DICT_UPDATE"] = "NODES_DICT_UPDATE";
    HierarchyGraphActionTypes["INITIAL_LOAD_FAILED"] = "INITIAL_LOAD_FAILED";
    HierarchyGraphActionTypes["SELECT_NODE"] = "SELECT_NODE";
    HierarchyGraphActionTypes["RESET_PENDING_SCROLL"] = "RESET_PENDING_SCROLL";
    HierarchyGraphActionTypes["HIDE_BELONGS_TO_NODES"] = "HIDE_RELATED_NODES";
    HierarchyGraphActionTypes["SHOW_BELONGS_TO_NODES"] = "SHOW_RELATED_NODES";
    HierarchyGraphActionTypes["LOAD_BELONGS_TO_NODES"] = "LOAD_RELATED_NODES";
    HierarchyGraphActionTypes["LOAD_MORE_BELONGS_TO_NODES"] = "LOAD_MORE_BELONGS_TO_NODES";
    HierarchyGraphActionTypes["LOAD_MORE_TOP_LEVEL_ORPHAN_NODES"] = "LOAD_MORE_TOP_LEVEL_ORPHAN_NODES";
    HierarchyGraphActionTypes["SELECT_NODE_UPDATE_INIT"] = "SELECT_NODE_UPDATE_INIT";
    HierarchyGraphActionTypes["SELECT_NODE_UPDATE_COMPLETE"] = "SELECT_NODE_UPDATE_COMPLETE";
    HierarchyGraphActionTypes["SELECT_NODE_UPDATE_FAILED"] = "SELECT_NODE_UPDATE_FAILED";
})(HierarchyGraphActionTypes = exports.HierarchyGraphActionTypes || (exports.HierarchyGraphActionTypes = {}));
var HierarchyNodeActionCreator = /** @class */ (function () {
    function HierarchyNodeActionCreator(hierarchyBaseUrl, includeOwners, hierarchyStateGetter) {
        var _this = this;
        this.toggleNode = function (nodeId, isExpanded) {
            return function (dispatch, getState) {
                // if it's expanded than we just have to callapse it
                if (isExpanded || isNodeFullyLoaded(_this.hierarchyStateGetter(getState()), nodeId)) {
                    return dispatch({ type: HierarchyGraphActionTypes.NODE_TOGGLE, nodeId: nodeId });
                }
                dispatch({ type: HierarchyGraphActionTypes.NODE_TOGGLE, nodeId: nodeId });
                return dispatch(_this.fetchNode(nodeId));
            };
        };
        this.fetchNode = function (nodeId, expandPath) {
            if (expandPath === void 0) { expandPath = false; }
            return function (dispatch, getState) {
                if (nodeId === Constants_1.Constants.ORPHAN_PLACEHOLDER_ID) {
                    return;
                }
                var hierarchyMetadataId = getHierarchyMetadataId(_this.hierarchyStateGetter(getState()));
                return axios_1.default
                    .get(_this.hierarchyBaseUrl +
                    hierarchyMetadataId +
                    '/nodes/' +
                    HtmlUtil_1.HtmlUtil.encodeUri(nodeId) +
                    "?expandPath=".concat(expandPath, "&includeOwners=").concat(!!_this.includeOwners))
                    .then(processResponse)
                    .then(function (body) {
                    var hierarchyVm = body;
                    dispatch({ type: HierarchyGraphActionTypes.NODES_DICT_UPDATE, nodeId: nodeId, hierarchyVm: hierarchyVm, expandPath: expandPath });
                    if (expandPath) {
                        dispatch(_this.selectNode(nodeId));
                    }
                })
                    .catch(function (ex) {
                    return dispatch({ type: HierarchyGraphActionTypes.INITIAL_LOAD_FAILED });
                });
            };
        };
        this.fetchNodAncestors = function (hierarchyNodeIds) {
            return function (dispatch, getState) {
                dispatch({ type: HierarchyGraphActionTypes.SELECT_NODE_UPDATE_INIT });
                var hierarchyMetadataId = getHierarchyMetadataId(_this.hierarchyStateGetter(getState()));
                return axios_1.default
                    .post(_this.hierarchyBaseUrl + hierarchyMetadataId + '/ancestor', hierarchyNodeIds)
                    .then(processResponse)
                    .then(function (body) {
                    var hierarchyVm = body;
                    dispatch({ type: HierarchyGraphActionTypes.SELECT_NODE_UPDATE_COMPLETE, hierarchyNodeIds: hierarchyNodeIds, hierarchyVm: hierarchyVm });
                })
                    .catch(function (ex) {
                    return dispatch({ type: HierarchyGraphActionTypes.SELECT_NODE_UPDATE_FAILED });
                });
            };
        };
        this.selectNode = function (nodeId) {
            return function (dispatch, getState) {
                if (nodeId === Constants_1.Constants.ORPHAN_PLACEHOLDER_ID) {
                    return;
                }
                dispatch({ type: HierarchyGraphActionTypes.SELECT_NODE, nodeId: nodeId });
            };
        };
        this.toggleShowBelongsToNodes = function (nodeId) {
            return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
                var node;
                var _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            node = this.hierarchyStateGetter(getState()).nodes[nodeId];
                            if (!node.showBelongsToNodes) return [3 /*break*/, 1];
                            dispatch({ type: HierarchyGraphActionTypes.HIDE_BELONGS_TO_NODES, nodeId: nodeId });
                            return [3 /*break*/, 4];
                        case 1:
                            if (!!((_a = node.belongsToNodeIds) === null || _a === void 0 ? void 0 : _a.length)) return [3 /*break*/, 3];
                            return [4 /*yield*/, dispatch(this.loadBelongsToNodes(nodeId))];
                        case 2:
                            _b.sent();
                            _b.label = 3;
                        case 3:
                            dispatch({ type: HierarchyGraphActionTypes.SHOW_BELONGS_TO_NODES, nodeId: nodeId });
                            _b.label = 4;
                        case 4: return [2 /*return*/];
                    }
                });
            }); };
        };
        this.loadBelongsToNodes = function (nodeId) {
            return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
                var hierarchyMetadataId, _a, nodes, pageRange;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            hierarchyMetadataId = getHierarchyMetadataId(this.hierarchyStateGetter(getState()));
                            return [4 /*yield*/, this.fetchBelongsToNodes(hierarchyMetadataId, nodeId)];
                        case 1:
                            _a = _b.sent(), nodes = _a.nodes, pageRange = _a.pageRange;
                            return [2 /*return*/, dispatch({ type: HierarchyGraphActionTypes.LOAD_BELONGS_TO_NODES, nodeId: nodeId, nodes: nodes, pageRange: pageRange })];
                    }
                });
            }); };
        };
        this.loadMoreBelongsToNodes = function (nodeId) {
            return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
                var node, _a, offset, limit, hierarchyMetadataId, _b, nodes, pageRange;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            node = this.hierarchyStateGetter(getState()).nodes[nodeId];
                            _a = node.belongsToPageRange, offset = _a.offset, limit = _a.limit;
                            hierarchyMetadataId = getHierarchyMetadataId(this.hierarchyStateGetter(getState()));
                            return [4 /*yield*/, this.fetchBelongsToNodes(hierarchyMetadataId, nodeId, offset + limit, limit)];
                        case 1:
                            _b = _c.sent(), nodes = _b.nodes, pageRange = _b.pageRange;
                            return [2 /*return*/, dispatch({ type: HierarchyGraphActionTypes.LOAD_MORE_BELONGS_TO_NODES, nodeId: nodeId, nodes: nodes, pageRange: pageRange })];
                    }
                });
            }); };
        };
        this.loadMoreTopLevelOrphanNodes = function () {
            return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
                var _a, offset, limit, hierarchyMetadataId, url, response, nodes, pageRange;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            _a = this.hierarchyStateGetter(getState()).orphanedDependentNodeIds.pageRange, offset = _a.offset, limit = _a.limit;
                            hierarchyMetadataId = getHierarchyMetadataId(this.hierarchyStateGetter(getState()));
                            url = "".concat(this.hierarchyBaseUrl).concat(hierarchyMetadataId, "/orphanNodes?type=Person") + "&offset=".concat(offset + limit, "&limit=").concat(limit);
                            return [4 /*yield*/, axios_1.default.get(url)];
                        case 1:
                            response = _b.sent();
                            nodes = processResponse(response);
                            pageRange = JSON.parse(response.headers.range);
                            return [2 /*return*/, dispatch({ type: HierarchyGraphActionTypes.LOAD_MORE_TOP_LEVEL_ORPHAN_NODES, nodes: nodes, pageRange: pageRange })];
                    }
                });
            }); };
        };
        this.resetPendingScroll = function () { return ({ type: HierarchyGraphActionTypes.RESET_PENDING_SCROLL }); };
        this.fetchBelongsToNodes = function (hierarchyMetadataId, nodeId, offset, limit) {
            if (offset === void 0) { offset = 0; }
            if (limit === void 0) { limit = 25; }
            return __awaiter(_this, void 0, void 0, function () {
                var url, response, nodes, pageRange;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            url = "".concat(this.hierarchyBaseUrl).concat(hierarchyMetadataId, "/nodes/").concat(nodeId, "/relationships/relationship?type=belongs_to&offset=").concat(offset, "&limit=").concat(limit);
                            return [4 /*yield*/, axios_1.default.get(url)];
                        case 1:
                            response = _a.sent();
                            nodes = processResponse(response);
                            pageRange = JSON.parse(response.headers.range);
                            return [2 /*return*/, { nodes: nodes, pageRange: pageRange }];
                    }
                });
            });
        };
        this.hierarchyBaseUrl = hierarchyBaseUrl;
        this.includeOwners = includeOwners;
        var defaultGetter = function (applicationState) { return applicationState.Hierarchy; };
        this.hierarchyStateGetter = hierarchyStateGetter || defaultGetter;
    }
    return HierarchyNodeActionCreator;
}());
exports.HierarchyNodeActionCreator = HierarchyNodeActionCreator;
var isNodeFullyLoaded = function (hierarchyVm, nodeId) {
    if (!hierarchyVm || !hierarchyVm.nodes) {
        return false;
    }
    var nodeVm = hierarchyVm.nodes[nodeId];
    return nodeVm.fullyLoaded;
};
var getHierarchyMetadataId = function (hierarchyVm) {
    return hierarchyVm.hierarchyHeader.hierarchyMetadataId;
};
var processResponse = function (response) {
    if (response.status === 200) {
        return response.data;
    }
    throw Error('Invalid response status - ' + response.status);
};
var HierarchyGraphReducer = function (state, incomingAction) {
    var _a, _b, _c, _d, _e, _f;
    var _g;
    if (!state) {
        return { isLoading: true };
    }
    switch (incomingAction.type) {
        case HierarchyGraphActionTypes.NODE_TOGGLE: {
            var nodeId = incomingAction.nodeId;
            var newHierarchy = __assign(__assign({}, state), { nodes: __assign(__assign({}, state.nodes), (_a = {}, _a[nodeId] = __assign(__assign({}, state.nodes[nodeId]), { isExpanded: !state.nodes[nodeId].isExpanded }), _a)) });
            // if collapsing a node, collapse all its children too
            if (state.nodes[nodeId].isExpanded) {
                (0, exports.collapseChildNodes)(newHierarchy, nodeId);
            }
            (0, exports.bubbleUpHierarchyNodeUpdates)(state, newHierarchy, nodeId);
            return newHierarchy;
        }
        case HierarchyGraphActionTypes.NODES_DICT_UPDATE: {
            var nodeId = incomingAction.nodeId, hierarchyVm = incomingAction.hierarchyVm, expandPath = incomingAction.expandPath;
            var nodes = __assign({}, state.nodes);
            var parentIds_1 = state.parentIds ? __assign({}, state.parentIds) : {};
            var hierarchyTypeUtil = HierarchyTypeUtil_1.HierarchyTypeUtilFactory.getHierarchyTypeUtil((_g = state.hierarchyHeader) === null || _g === void 0 ? void 0 : _g.hierarchyType);
            // Update nodes hashtable based on the api response
            if (hierarchyVm && hierarchyVm.nodes) {
                var _loop_1 = function (item) {
                    if (hierarchyVm.nodes.hasOwnProperty(item)) {
                        var existingChildren = nodes[item] ? nodes[item].childrenIds : [];
                        var apiNode = hierarchyVm.nodes[item];
                        nodes[item] = __assign(__assign({}, nodes[item]), apiNode);
                        // if the node from the api comes without the child ids populated. Don't overwrite what is already in the store
                        if (!hierarchyTypeUtil.isLeafNode(apiNode) && apiNode.childrenIds.length === 0) {
                            nodes[item] = __assign(__assign({}, nodes[item]), { childrenIds: existingChildren });
                        }
                        nodes[item].childrenIds.forEach(function (childNodeId) {
                            parentIds_1[childNodeId] = item;
                        });
                    }
                };
                for (var item in hierarchyVm.nodes) {
                    _loop_1(item);
                }
            }
            // get new state
            var newHierarchy = __assign(__assign({}, state), { editInProgress: false, parentIds: parentIds_1, nodes: __assign(__assign({}, nodes), (_b = {}, _b[nodeId] = __assign(__assign({}, nodes[nodeId]), { fullyLoaded: true }), _b)) });
            (0, exports.bubbleUpHierarchyNodeUpdates)(state, newHierarchy, nodeId, expandPath);
            if (expandPath) {
                newHierarchy.selectedNodeId = nodeId;
                newHierarchy.pendingSelectedNodeScroll = true;
            }
            return newHierarchy;
        }
        case HierarchyGraphActionTypes.INITIAL_LOAD_FAILED:
            return __assign(__assign({}, state), { isLoading: false });
        case HierarchyGraphActionTypes.SELECT_NODE: {
            var data = incomingAction;
            var updatedState = __assign(__assign({}, state), { nodes: __assign({}, state.nodes), selectedNodeId: data.nodeId });
            (0, exports.bubbleUpHierarchyNodeUpdates)(state, updatedState, data.nodeId);
            return updatedState;
        }
        case HierarchyGraphActionTypes.RESET_PENDING_SCROLL: {
            return __assign(__assign({}, state), { pendingSelectedNodeScroll: undefined });
        }
        case HierarchyGraphActionTypes.HIDE_BELONGS_TO_NODES: {
            var updatedState = __assign(__assign({}, state), { nodes: __assign(__assign({}, state.nodes), (_c = {}, _c[incomingAction.nodeId] = __assign(__assign({}, state.nodes[incomingAction.nodeId]), { showBelongsToNodes: false }), _c)) });
            (0, exports.bubbleUpHierarchyNodeUpdates)(state, updatedState, incomingAction.nodeId, false);
            return updatedState;
        }
        case HierarchyGraphActionTypes.SHOW_BELONGS_TO_NODES: {
            var nodes = state.nodes;
            if (!nodes) {
                return state;
            }
            var updatedState = __assign(__assign({}, state), { nodes: __assign(__assign({}, nodes), (_d = {}, _d[incomingAction.nodeId] = __assign(__assign({}, nodes[incomingAction.nodeId]), { showBelongsToNodes: true }), _d)) });
            (0, exports.bubbleUpHierarchyNodeUpdates)(state, updatedState, incomingAction.nodeId, false);
            return updatedState;
        }
        case HierarchyGraphActionTypes.LOAD_BELONGS_TO_NODES: {
            var nodes = state.nodes;
            var belongsToNodes = incomingAction.nodes, targetNodeId_1 = incomingAction.nodeId, pageRange = incomingAction.pageRange;
            if (!nodes) {
                return state;
            }
            var newNodeState = __assign(__assign({}, nodes[targetNodeId_1]), (belongsToNodes && {
                belongsToNodeIds: belongsToNodes.map(function (n) { return n.nodeId; }),
                belongsToPageRange: pageRange,
            }));
            var newState = __assign(__assign({}, state), { nodes: __assign(__assign(__assign({}, nodes), (_e = {}, _e[targetNodeId_1] = newNodeState, _e)), (belongsToNodes && Object.assign.apply(Object, __spreadArray([{}], belongsToNodes.map(function (n) {
                    var _a;
                    return (_a = {}, _a[n.nodeId] = n, _a);
                }), false)))), parentIds: __assign(__assign({}, state.parentIds), (belongsToNodes && Object.assign.apply(Object, __spreadArray([{}], belongsToNodes.map(function (n) {
                    var _a;
                    return (_a = {}, _a[n.nodeId] = targetNodeId_1, _a);
                }), false)))) });
            (0, exports.bubbleUpHierarchyNodeUpdates)(state, newState, incomingAction.nodeId, false);
            return newState;
        }
        case HierarchyGraphActionTypes.LOAD_MORE_BELONGS_TO_NODES: {
            var nodes = state.nodes;
            var belongsToMoreNodes = incomingAction.nodes, targetNodeId_2 = incomingAction.nodeId, pageRange = incomingAction.pageRange;
            if (!nodes) {
                return state;
            }
            var currentlyNode = nodes[targetNodeId_2];
            var newNodeState = __assign(__assign({}, currentlyNode), { showBelongsToNodes: true, belongsToNodeIds: __spreadArray(__spreadArray([], (currentlyNode.belongsToNodeIds || []), true), belongsToMoreNodes.map(function (n) { return n.nodeId; }), true), belongsToPageRange: pageRange });
            var newState = __assign(__assign({}, state), { nodes: __assign(__assign(__assign({}, nodes), (_f = {}, _f[targetNodeId_2] = newNodeState, _f)), Object.assign.apply(Object, __spreadArray([{}], belongsToMoreNodes.map(function (n) {
                    var _a;
                    return (_a = {}, _a[n.nodeId] = n, _a);
                }), false))), parentIds: __assign(__assign({}, state.parentIds), Object.assign.apply(Object, __spreadArray([{}], belongsToMoreNodes.map(function (n) {
                    var _a;
                    return (_a = {}, _a[n.nodeId] = targetNodeId_2, _a);
                }), false))) });
            (0, exports.bubbleUpHierarchyNodeUpdates)(state, newState, incomingAction.nodeId, false);
            return newState;
        }
        case HierarchyGraphActionTypes.LOAD_MORE_TOP_LEVEL_ORPHAN_NODES: {
            var allNodes_1 = __assign({}, state.nodes);
            var orphanedDependentNodeIdList_1 = __spreadArray([], state.orphanedDependentNodeIds.items, true);
            if (incomingAction.nodes) {
                incomingAction.nodes.forEach(function (n) {
                    allNodes_1[n.nodeId] = n;
                    orphanedDependentNodeIdList_1.push(n.nodeId);
                });
            }
            return __assign(__assign({}, state), { orphanedDependentNodeIds: {
                    items: orphanedDependentNodeIdList_1,
                    pageRange: incomingAction.pageRange,
                }, nodes: __assign({}, allNodes_1) });
        }
        case HierarchyGraphActionTypes.SELECT_NODE_UPDATE_COMPLETE: {
            var selectNodeUpdateAction = incomingAction;
            var invalidNodeIds = {};
            var nodes = __assign({}, state.nodes);
            var parentIds_2 = state.parentIds ? __assign({}, state.parentIds) : {};
            var _loop_2 = function (id) {
                if (selectNodeUpdateAction.hierarchyNodeIds.hasOwnProperty(id)) {
                    var item_1 = selectNodeUpdateAction.hierarchyNodeIds[id];
                    var nodesList = selectNodeUpdateAction.hierarchyVm.nodes;
                    if (nodesList === undefined) {
                        return "continue";
                    }
                    if (!(selectNodeUpdateAction.hierarchyNodeIds[id] in nodesList)) {
                        invalidNodeIds[item_1] = true;
                    }
                    else {
                        nodes[item_1] = __assign(__assign({}, nodesList[item_1]), nodes[item_1]);
                        if (nodes[item_1].childrenIds) {
                            nodes[item_1].childrenIds.forEach(function (childNodeId) {
                                parentIds_2[childNodeId] = item_1;
                            });
                        }
                    }
                }
            };
            // Update nodes hashtable based on the api response
            for (var id in selectNodeUpdateAction.hierarchyNodeIds) {
                _loop_2(id);
            }
            // get new state
            return __assign(__assign({}, state), { parentIds: parentIds_2, nodes: nodes, isLoading: false, invalidNodeIds: invalidNodeIds });
        }
        case HierarchyGraphActionTypes.SELECT_NODE_UPDATE_FAILED: {
            if (state.isLoading) {
                return __assign(__assign({}, state), { isLoading: false });
            }
            else {
                return state;
            }
        }
        case HierarchyGraphActionTypes.SELECT_NODE_UPDATE_INIT: {
            if (!state.isLoading) {
                return __assign(__assign({}, state), { isLoading: true });
            }
            else {
                return state;
            }
        }
        default:
            return state;
    }
};
exports.HierarchyGraphReducer = HierarchyGraphReducer;
var collapseChildNodes = function (hierarchyVm, nodeId) {
    if (nodeId && hierarchyVm.nodes && hierarchyVm.nodes[nodeId]) {
        // if collapsing a node, collapse all its children too
        if (!hierarchyVm.nodes[nodeId].isExpanded) {
            var childIds = hierarchyVm.nodes[nodeId].childrenIds;
            childIds.forEach(function (id) {
                if (hierarchyVm.nodes[id] && hierarchyVm.nodes[id].isExpanded) {
                    hierarchyVm.nodes[id] = __assign(__assign({}, hierarchyVm.nodes[id]), { isExpanded: false });
                    (0, exports.collapseChildNodes)(hierarchyVm, id);
                }
            });
        }
    }
};
exports.collapseChildNodes = collapseChildNodes;
var bubbleUpHierarchyNodeUpdates = function (origHierarchyVm, hierarchyVm, nodeId, expandPath) {
    if (!nodeId || !hierarchyVm.nodes || !hierarchyVm.nodes[nodeId] || !hierarchyVm.parentIds || !origHierarchyVm.nodes) {
        return;
    }
    if (origHierarchyVm === hierarchyVm || origHierarchyVm.nodes === hierarchyVm.nodes) {
        throw Error('Invalid hierarchyVm');
    }
    if (expandPath) {
        hierarchyVm.nodes[nodeId] = __assign(__assign({}, hierarchyVm.nodes[nodeId]), { isExpanded: true });
    }
    else {
        hierarchyVm.nodes[nodeId] = __assign({}, hierarchyVm.nodes[nodeId]);
    }
    if (!hierarchyVm.parentIds[nodeId] || nodeId === hierarchyVm.parentIds[nodeId]) {
        return;
    }
    (0, exports.bubbleUpHierarchyNodeUpdates)(origHierarchyVm, hierarchyVm, hierarchyVm.parentIds[nodeId], expandPath);
};
exports.bubbleUpHierarchyNodeUpdates = bubbleUpHierarchyNodeUpdates;
